import React from 'react';
import { Stack } from '@mui/material';
import appConfig from '../../../config/appConfig';
import { useSignupReferral } from '../hooks/useSignupReferral';

const SignupBrandLogos = ({ variant = 'form' }) => {
  const { partner, showPartnerLogo } = useSignupReferral();
  const isWaiting = variant === 'waiting';

  if (!showPartnerLogo) {
    return (
      <Stack sx={{ alignItems: 'center', mb: isWaiting ? 2 : 4 }}>
        <img
          src={appConfig.brandLogoPath}
          alt={`${appConfig.brandName} logo`}
          width={isWaiting ? undefined : '50%'}
          style={isWaiting ? { maxWidth: '200px', height: 'auto' } : undefined}
        />
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        mb: isWaiting ? 2 : 4,
        width: '100%',
      }}
    >
      <img
        src={appConfig.brandLogoPath}
        alt={`${appConfig.brandName} logo`}
        width={isWaiting ? undefined : '35%'}
        style={isWaiting ? { maxWidth: '160px', height: 'auto' } : undefined}
      />
      <img
        src={partner.logoPath}
        alt={`${partner.name} logo`}
        width={isWaiting ? undefined : '35%'}
        style={isWaiting ? { maxWidth: '160px', height: 'auto' } : undefined}
      />
    </Stack>
  );
};

export default SignupBrandLogos;
